import React from 'react'

function TechSelectKLE() {
  return (
    <embed src="\pdfs\E2.2.1_kl-e-klappe-07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectKLE